export class RequestTripDetail {
    tripId: number
    license: string
    truckNumber: string
    dotNumber: string
    truckType: number
}